import React, { useEffect, useState } from "react";
import { IoSearchOutline } from "react-icons/io5";
import { FaMapMarkerAlt, FaBriefcase, FaGraduationCap, FaMoneyBillAlt, FaCalendarAlt, FaUsers, FaTransgender } from "react-icons/fa";
import { Description } from '@mui/icons-material'; // Example icon
import { Divider, Box, Grid, Typography, Checkbox, FormControlLabel, Drawer, IconButton } from "@mui/material";
import { FaChevronDown, FaChevronUp, FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { getDroneJobs } from "../../redux/slice/droneJobsSlice";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { getSingleDroneJob } from "../../redux/slice/droneJobsSlice";

const JobHireHero = () => {

  // State for filters
  const [location, setLocation] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [salaryRange, setSalaryRange] = useState([]);

  // Toggle functions for filters
  const [isLocationOpen, setIsLocationOpen] = useState(false);
  const [isJobTypeOpen, setIsJobTypeOpen] = useState(false);
  const [isSalaryOpen, setIsSalaryOpen] = useState(false);

  const [search, setSearch] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [industry, setIndustry] = useState([]);
  const [jobCategory, setJobCategory] = useState([]);
  const [page, setPage] = useState(1);
  const [allJobs, setAllJobs] = useState([]);
  const dispatch = useDispatch();
  const { droneJobs, totalPage } = useSelector((state) => state.droneJob);
  const [totalJobs, setTotalJobs] = useState(0); // New state for total job count
  const [isIndustryOpen, setIsIndustryOpen] = useState(false);
  const [isJobCategoryOpen, setIsJobCategoryOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const { droneJobDetails } = useSelector((state) => state.droneJob);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  

  const toggleLocationFilter = () => setIsLocationOpen(!isLocationOpen);
const toggleJobTypeFilter = () => setIsJobTypeOpen(!isJobTypeOpen);
const toggleSalaryFilter = () => setIsSalaryOpen(!isSalaryOpen);

// State for filter options
  const [filterOptions, setFilterOptions] = useState({
    locations: [],
    jobTypes: [],
    industries: [],
    jobCategories: []
  });

  useEffect(() => {
    if (allJobs.length > 0) {
      setFilterOptions({
        locations: [...new Set(allJobs.map(job => job.locationName).filter(Boolean))],
        jobTypes: [...new Set(allJobs.map(job => job.jobType).filter(Boolean))],
        industries: [...new Set(allJobs.map(job => job.Industry).filter(Boolean))],
        jobCategories: [...new Set(allJobs.map(job => job.JobCategory).filter(Boolean))]
      });
    }
  }, [allJobs]);


  useEffect(() => {
    dispatch(getSingleDroneJob(id));
  }, [id, dispatch]);

  const openModal = () => {
    if (selectedJob) {
      navigate(`/quick-registration-form/${selectedJob._id}`);
    } else {
      console.log("No job selected.");
    }
  };
  
  useEffect(() => {
    setLoading(true);
    dispatch(getDroneJobs({ page: page, limit: 1000 }));
  }, [dispatch]);

  useEffect(() => {
    if (droneJobs.length > 0) {
      setAllJobs((prevJobs) => [...prevJobs, ...droneJobs]);
      setLoading(false);
    }
  }, [droneJobs]);
  

  const handleFilterChange = (filterType, value) => {
  switch (filterType) {
    case "location":
      setLocation(prev => 
        prev.includes(value) ? prev.filter(item => item !== value) : [...prev, value]
      );
      break;
    case "jobType":
      setJobType(prev => 
        prev.includes(value) ? prev.filter(item => item !== value) : [...prev, value]
      );
      break;
    case "salaryRange":
      setSalaryRange(prev => 
        prev.includes(value) ? prev.filter(item => item !== value) : [...prev, value]
      );
      break;
    case "industry":
      setIndustry(prev => 
        prev.includes(value) ? prev.filter(item => item !== value) : [...prev, value]
      );
      break;
    case "jobCategory":
      setJobCategory(prev => 
        prev.includes(value) ? prev.filter(item => item !== value) : [...prev, value]
      );
      break;
    default:
      break;
  }
};

  const toggleIndustryFilter = () => {
    setIsIndustryOpen(!isIndustryOpen);
  };

  const toggleJobCategoryFilter = () => {
    setIsJobCategoryOpen(!isJobCategoryOpen);
  };

  const filteredJobs = Array.from(new Set(allJobs.map((a) => a._id)))
  .map((id) => allJobs.find((a) => a._id === id))
  .filter((job) => {
    const title = job.title?.toLowerCase() || "";
    const jobCompanyName = job.companyName?.toLowerCase() || "";
    const jobLocation = job.locationName?.toLowerCase() || "";
    const jobSalary = job.salary?.toLowerCase() || "";
    const jobIndustry = job.Industry?.toLowerCase() || "";
    const jobJobCategory = job.JobCategory?.toLowerCase() || "";

    // Text search filters
    const matchesSearch = search === "" || title.includes(search.toLowerCase());
    const matchesCompany = companyName === "" || jobCompanyName.includes(companyName.toLowerCase());
    
    // Location filter
    const matchesLocation = location.length === 0 || 
      location.some(loc => jobLocation.includes(loc.toLowerCase()));
    
    // Job Type filter
    const matchesJobType = jobType.length === 0 || 
      jobType.some(type => job.jobType?.toLowerCase().includes(type.toLowerCase()));
    
    // Salary Range filter
    const matchesSalary = salaryRange.length === 0 || 
      salaryRange.some(range => {
        if (range === "50k+") {
          return parseInt(jobSalary.replace(/[^0-9]/g, '')) >= 50000;
        }
        const [min, max] = range.split('-').map(s => parseInt(s.replace(/[^0-9]/g, '')));
        const jobSalaryNum = parseInt(jobSalary.replace(/[^0-9]/g, ''));
        return jobSalaryNum >= min && jobSalaryNum <= max;
      });
    
    // Industry filter
    const matchesIndustry = industry.length === 0 || 
      industry.some(ind => jobIndustry.includes(ind.toLowerCase()));
    
    // Job Category filter
    const matchesJobCategory = jobCategory.length === 0 || 
      jobCategory.some(cat => jobJobCategory.includes(cat.toLowerCase()));

    return (
      matchesSearch &&
      matchesCompany &&
      matchesLocation &&
      matchesJobType &&
      matchesSalary &&
      matchesIndustry &&
      matchesJobCategory
    );
  });

  const handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (scrollTop + windowHeight >= documentHeight - 10 && page < totalPage && !loading) {
      setLoading(true);
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [page, totalPage, loading]);

  // const openModal = () => {
  //   navigate(`/quick-registration-form/${droneJobDetails?._id}`);
  // };

  const handleDrawerOpen = (job) => {
    setSelectedJob(job);
  };
  

  const handleDrawerClose = () => { 
    setSelectedJob(null);
  };

  return (
    <div className="container pt-5">
      <Grid container spacing={4}>
        {/* Display Available Jobs Count */}
        <Grid item xs={12}>
        <Typography variant="h6" sx={{ mb: -2, ml: 1, fontWeight: 600, fontSize: 15, color: 'text.primary' }}>
          There are {filteredJobs.length} job{filteredJobs.length !== 1 ? 's' : ''} waiting for you
        </Typography>
      </Grid>

        {/* Filters Sidebar */}
        <Grid item xs={12} md={3} sx={{ mb: 2 }}>
  <Box
    p={3}
    sx={{
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
      borderRadius: 4,
      position: 'sticky',
      top: 100,
      backgroundColor: 'background.paper',
      maxHeight: 'calc(100vh - 120px)',
      overflowY: 'auto',
      '&::-webkit-scrollbar': { display: 'none' },
      scrollbarWidth: 'none',
      WebkitOverflowScrolling: 'touch'
    }}
  >
    <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: 'primary.main' }}>
      Filter Jobs
    </Typography>
    <Divider sx={{ mb: 3, borderColor: 'divider' }} />

    {/* Search Inputs */}
    <Box mb={3}>
      <Box
        display="flex"
        alignItems="center"
        mb={2}
        sx={{
          backgroundColor: 'action.hover',
          borderRadius: 2,
          px: 2,
          py: 1
        }}
      >
        <IoSearchOutline style={{ fontSize: '20px', color: 'text.secondary' }} />
        <input
          type="text"
          placeholder="Search Jobs"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            marginLeft: '10px',
            padding: '8px',
            width: '100%',
            border: 'none',
            backgroundColor: 'transparent',
            fontSize: '0.875rem',
            outline: 'none'
          }}
        />
      </Box>

      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: 'action.hover',
          borderRadius: 2,
          px: 2,
          py: 1
        }}
      >
        <FaMapMarkerAlt style={{ fontSize: '16px', color: 'text.secondary' }} />
        <input
          type="text"
          placeholder="Search by Company"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          style={{
            marginLeft: '10px',
            padding: '8px',
            width: '100%',
            border: 'none',
            backgroundColor: 'transparent',
            fontSize: '0.875rem',
            outline: 'none'
          }}
        />
      </Box>
    </Box>

    <Divider sx={{ my: 3, borderColor: 'divider' }} />

    {/* Location Filter */}
  {/* Location Filter */}
  <Box mb={3}>
    <Box
      onClick={toggleLocationFilter}
      display="flex"
      justifyContent="space-between"
      sx={{
        cursor: 'pointer',
        alignItems: 'center',
        py: 1,
        '&:hover': { backgroundColor: 'action.hover' },
        borderRadius: 1
      }}
    >
      <Typography variant="subtitle1" fontWeight={600}>Location</Typography>
      {isLocationOpen ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
    </Box>

    {isLocationOpen && (
      <Box sx={{ ml: 1, mt: 1 }}>
        {['Noida', 'Delhi', 'Bangalore', 'Hyderabad', 'Mumbai', 'Pune'].map((loc) => (
          <Box key={loc} sx={{ display: 'flex', alignItems: 'center', my: 0.5 }}>
            <Checkbox
              size="small"
              checked={location.includes(loc)}
              onChange={() => handleFilterChange("location", loc)}
              sx={{
                color: 'text.secondary',
                '&.Mui-checked': { color: 'primary.main' },
                padding: '4px'
              }}
            />
            <Typography variant="body2" sx={{ ml: 1 }}>{loc}</Typography>
          </Box>
        ))}
      </Box>
    )}
  </Box>

  <Divider sx={{ my: 3, borderColor: 'divider' }} />

  {/* Job Type Filter */}
    <Box mb={3}>
      <Box
        onClick={toggleJobTypeFilter}
        display="flex"
        justifyContent="space-between"
        sx={{
          cursor: 'pointer',
          alignItems: 'center',
          py: 1,
          '&:hover': { backgroundColor: 'action.hover' },
          borderRadius: 1
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>Job Type</Typography>
        {isJobTypeOpen ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
      </Box>

      {isJobTypeOpen && (
  <Box sx={{ ml: 1, mt: 1 }}>
    {filterOptions.jobTypes.map((typeItem) => (
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            sx={{
              color: 'text.secondary',
              '&.Mui-checked': { color: 'primary.main' }
            }}
            checked={jobType.includes(typeItem)}
            onChange={() => handleFilterChange("jobType", typeItem)}
          />
        }
        label={<Typography variant="body2">{typeItem}</Typography>}
        key={typeItem}
        sx={{ display: 'flex', alignItems: 'center', my: 0.5 }}
      />
    ))}
  </Box>
)}
    </Box>

    <Divider sx={{ my: 3, borderColor: 'divider' }} />

    {/* Industry Filter */}
    <Box mb={3}>
      <Box
        onClick={toggleIndustryFilter}
        display="flex"
        justifyContent="space-between"
        sx={{
          cursor: 'pointer',
          alignItems: 'center',
          py: 1,
          '&:hover': { backgroundColor: 'action.hover' },
          borderRadius: 1
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>Industry</Typography>
        {isIndustryOpen ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
      </Box>

      {isIndustryOpen && (
  <Box sx={{ ml: 1, mt: 1 }}>
    {filterOptions.industries.map((industryItem) => (
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            sx={{
              color: 'text.secondary',
              '&.Mui-checked': { color: 'primary.main' }
            }}
            checked={industry.includes(industryItem)}
            onChange={() => handleFilterChange("industry", industryItem)}
          />
        }
        label={<Typography variant="body2">{industryItem}</Typography>}
        key={industryItem}
        sx={{ display: 'flex', alignItems: 'center', my: 0.5 }}
      />
    ))}
  </Box>
)}
    </Box>

    <Divider sx={{ my: 3, borderColor: 'divider' }} />

    {/* Salary Range Filter */}
    <Box mb={3}>
      <Box
        onClick={toggleSalaryFilter}
        display="flex"
        justifyContent="space-between"
        sx={{
          cursor: 'pointer',
          alignItems: 'center',
          py: 1,
          '&:hover': { backgroundColor: 'action.hover' },
          borderRadius: 1
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>Salary Range</Typography>
        {isSalaryOpen ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
      </Box>

      {isSalaryOpen && (
        <Box sx={{ ml: 1, mt: 1 }}>
          {["0-10k", "10k-20k", "20k-30k", "30k-50k", "50k+"].map((salaryItem) => (
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  sx={{
                    color: 'text.secondary',
                    '&.Mui-checked': { color: 'primary.main' }
                  }}
                  checked={salaryRange.includes(salaryItem)}
                  onChange={() => handleFilterChange("salaryRange", salaryItem)}
                />
              }
              label={<Typography variant="body2">{salaryItem}</Typography>}
              key={salaryItem}
              sx={{ display: 'flex', alignItems: 'center', my: 0.5 }}
            />
          ))}
        </Box>
      )}
    </Box>

    <Divider sx={{ my: 3, borderColor: 'divider' }} />

    {/* Job Category Filter */}
    <Box>
      <Box
        onClick={toggleJobCategoryFilter}
        display="flex"
        justifyContent="space-between"
        sx={{
          cursor: 'pointer',
          alignItems: 'center',
          py: 1,
          '&:hover': { backgroundColor: 'action.hover' },
          borderRadius: 1
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>Job Category</Typography>
        {isJobCategoryOpen ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
      </Box>

      {isJobCategoryOpen && (
  <Box sx={{ ml: 1, mt: 1 }}>
    {filterOptions.jobCategories.map((categoryItem) => (
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            sx={{
              color: 'text.secondary',
              '&.Mui-checked': { color: 'primary.main' }
            }}
            checked={jobCategory.includes(categoryItem)}
            onChange={() => handleFilterChange("jobCategory", categoryItem)}
          />
        }
        label={<Typography variant="body2">{categoryItem}</Typography>}
        key={categoryItem}
        sx={{ display: 'flex', alignItems: 'center', my: 0.5 }}
      />
    ))}
  </Box>
)}
    </Box>
  </Box>
</Grid>

        {/* Job Cards Section */}
        <Grid item xs={12} md={9}>
  <Grid container spacing={3} sx={{mb: 2}}>
    {filteredJobs.length > 0 ? (
      filteredJobs.map((item, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Box
            className="job-card"
            sx={{
              p: 2.5,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 3,
              boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.06)',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              height: '100%', // Let the card take up the full height of its parent
              position: 'relative', // Keep this for positioning the image and button
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
              },
            }}
            onClick={() => handleDrawerOpen(item)}
          >
            {/* Image Section */}
            <img
              src={item.image}
              alt="company logo"
              style={{
                position: 'absolute',
                top: 16, // Adjust to control the spacing from the top
                left: 16, // Adjust to control the spacing from the left
                width: '48px',
                height: '48px',
                borderRadius: '8px',
                objectFit: 'contain',
                border: '1px solid #f0f0f0',
                zIndex: 2, // Ensure image is behind the button
              }}
            />
            
            {/* Job Opening Button */}
            <button
              className="ff_inter fs_10 job_btn border-0 p-2 text-white fw-bold"
              style={{
                position: 'absolute',
                top: '16px', // Keep the top aligned with the image
                right: '16px', // Position it on the right side of the card
                backgroundColor: '#007bff', // Button color
                borderRadius: '4px',
                zIndex: 3, // Ensure the button is on top of the image
                padding: '8px 16px', // Add padding for the button
                maxWidth: '120px', // Make sure the button width doesn't exceed the card bounds
                overflow: 'hidden',
                textOverflow: 'ellipsis', // Add ellipsis for long text
              }}
            >
              Job Opening
            </button>

            {/* Title and Company Name Section */}
            <Box sx={{ ml: 1, mt: 8, flexGrow: 1 }}> {/* Adjust margin-top to move content down and left */}
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  lineHeight: 1.3,
                  color: 'text.primary',
                }}
              >
                {item.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mt: 0.5,
                  color: 'primary.main',
                  fontWeight: 500,
                }}
              >
                {item.companyName}
              </Typography>
            </Box>

            {/* Location Section */}
            <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
              <FaMapMarkerAlt style={{ fontSize: '14px', color: 'text.secondary' }} />
              <Typography variant="body2" sx={{ ml: 1, color: 'text.secondary' }}>
                {item.locationName}
              </Typography>
            </Box>

            {/* Posted Date Section */}
            <Box sx={{ mt: 'auto', pt: 1 }}>
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  fontSize: '0.75rem',
                  fontWeight: 500,
                }}
              >
                Posted: {item.date}
              </Typography>
            </Box>
          </Box>
        </Grid>
      ))
    ) : (
      <Box
      sx={{
        width: '100%',
        textAlign: 'center',
        paddingTop: {
          xs: '10px', // small padding on mobile
          sm: '180px', // larger padding on larger screens
        },
      }}
    >
      <Typography variant="h6" color="textSecondary">
        No jobs found matching your criteria.
      </Typography>
    </Box>
    )}
  </Grid>
</Grid>


      </Grid>

      {/* Job Details Drawer */}
      <Drawer
      anchor="right"
      open={Boolean(selectedJob)}
      onClose={handleDrawerClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '90%', sm: '60%', md: '40%' },
          boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.12)',
          // borderRadius: '12px 0 0 12px',
          padding: 2,
        },
      }}
    >
      <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Close Button */}
        <IconButton
          onClick={handleDrawerClose}
          sx={{ position: 'absolute', right: 16, top: -5, color: 'text.secondary' }}
        >
          <FaTimes size={20} />
        </IconButton>

        {/* Job Header */}
        <Box display="flex" alignItems="center" gap={2}>
          <img
            src={selectedJob?.image}
            alt="Company"
            style={{ width: 56, height: 56, borderRadius: '12px', objectFit: 'contain', border: '1px solid #f0f0f0' }}
          />
          <Box>
            <Typography variant="h6" fontWeight={700} color="text.primary">
              {selectedJob?.title}
            </Typography>
            <Typography variant="body1" color="primary.main" fontWeight={500}>
              {selectedJob?.companyName}
            </Typography>
          </Box>
        </Box>

        {/* Job Details */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {[{ icon: <FaMapMarkerAlt />, text: selectedJob?.locationName },
            { icon: <FaMoneyBillAlt />, text: selectedJob?.salary },
            { icon: <FaCalendarAlt />, text: `Posted: ${selectedJob?.date}` },
            { icon: <FaUsers />, text: `Type: ${selectedJob?.jobType}` }].map((item, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box sx={{ color: 'primary.main', fontSize: 20 }}>{item.icon}</Box>
              <Typography variant="body2" color="text.secondary">
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Job Summary */}
        <Box>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
    <Description sx={{ fontSize: 25 }} />  {/* Icon before the text */}
    <Typography variant="h6" fontWeight={600} color="text.primary" sx={{ mb: 0 }}>
      Job Summary
    </Typography>
  </Box>
  <Typography
    variant="body2"
    sx={{ color: 'text.secondary', lineHeight: 1.6, textAlign: 'justify' }}
    dangerouslySetInnerHTML={{ __html: selectedJob?.jobSummary }}
  />
</Box>



        {/* Apply Button */}
        <Box>
          <button
            onClick={openModal}
            style={{
              backgroundColor: '#1976d2',
              color: 'white',
              padding: '14px 28px',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer',
              width: '100%',
              fontWeight: 600,
              fontSize: '1rem',
              transition: 'all 0.3s ease-in-out',
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#1565c0')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#1976d2')}
          >
            Apply Now
          </button>
        </Box>
      </Box>
    </Drawer>
    </div>
  );
};

export default JobHireHero;